import { createFileRoute } from '@tanstack/react-router'
import { RunSummaryDevScreen } from '~/boggle/ui/screens/RunSummaryDevScreen'

export const Route = createFileRoute('/dev/run-summary')({
  head: () => ({
    meta: [
      { title: 'Run summary (dev) — Patter' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
  component: DevRunSummaryRoute,
})

function DevRunSummaryRoute() {
  return <RunSummaryDevScreen />
}
